const getAllPages = state => state?.page?.allPages;
const getSinglePage = state => state?.page?.singlePage;
const getSinglePageErrors = state => state?.page?.singlePageErrors;
const getPagesStatus = state => state?.page?.status;
const getAllPagesQueryParams = state => state?.page?.queryParams;

export { getAllPages, getSinglePage, getPagesStatus, getSinglePageErrors, getAllPagesQueryParams };
